//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import coutDown from './vue2-countdown'
import { nowInDateBetwen, getRequest } from '@/libs/utils'
import { getUserinfo } from '@/api/user'
import {
  getView
} from '@/api/youzheng'
import Storage from '@/storage'
export default {
  components: {
    coutDown
  },
  data () {
    return {
      partyid: this.$route.params.artid,
      obj: {},
      startTime: '',
      endTime: '',
      currentTime: new Date().getTime(),
      status: 0, // 1征集，2投票活动
      tipText: '',
      tipTextEnd: '',
      endText: ''
    }
  },
  computed: {
    userid () {
      return this.$store.state.user.userid
    }
  },
  created () {
    this.view()
    this.getuser()
  },
  mounted () {
  },
  methods: {
    // 获取用户抽奖信息
    view () {
      getView({
        id: this.partyid
      }).then(res => {
        this.obj = res.obj
        this.getStatus()
      })
    },
    getuser () {
      Storage.set('token', '')
      getUserinfo({
        code: getRequest().code,
        userid: this.$store.state.user.userid
      }).then(res => {
        if (res.status === 'suc') {
          if (!res.returnValue.userid) {
            this.$vux.alert.show({
              title: '请求出错',
              content: '您不是该企业用户成员'
            })
          } else {
            Storage.set('token', res.returnValue.token)
          }
        }
      })
    },
    getStatus () {
      let status1 = nowInDateBetwen( // 0还未开始，1正在进行，-1结束
        this.obj.collectstartdate,
        this.obj.collectenddate
      )
      let status2 = nowInDateBetwen( // 0还未开始，1正在进行，-1结束
        this.obj.votestartdate,
        this.obj.voteenddate
      )
      if (status1 === 0 || status1 === 1 || (status1 === -1 && status2 === 0)) {
        this.status = 1
        this.tipText = '距离征集开始还有'
        this.tipTextEnd = '距离征集结束还有'
        this.endText = '征集已结束'
        this.startTime = this.obj.collectstartdate.replace(/-/g, '/')
        this.endTime = this.obj.collectenddate.replace(/-/g, '/')
        if (this.$route.name === 'chuyidasaiList' || this.$route.name === 'chuyidasaiMain') {
          this.$router.replace({ name: 'chuyidasaiIndex' })
        }
      } else if (status2 === 1 || status2 === -1) {
        this.status = 2
        this.tipText = '距离投票开始还有'
        this.tipTextEnd = '距离投票结束还有'
        this.endText = '投票已结束'
        this.startTime = this.obj.votestartdate.replace(/-/g, '/')
        this.endTime = this.obj.voteenddate.replace(/-/g, '/')
        if (this.$route.name === 'chuyidasaiIndex' || this.$route.name === 'chuyidasaiMain') {
          this.$router.replace({ name: 'chuyidasaiList' })
        }
      }
    }
  },
  watch: {
    '$route.name' () {
      this.getStatus()
    }
  }
}
